import { render, staticRenderFns } from "./ReImpresionBoletos2.vue?vue&type=template&id=05be7e8e&scoped=true&"
import script from "./ReImpresionBoletos2.vue?vue&type=script&lang=js&"
export * from "./ReImpresionBoletos2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05be7e8e",
  null
  
)

export default component.exports